// src/pages/Utilisateurs/components/UsersFiltersBar.jsx
import React from "react";
import { FaFilter, FaSearch, FaTimes } from "react-icons/fa";

const INPUT =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:border-indigo-500 dark:focus:ring-indigo-950";

export default function UsersFiltersBar({
  q,
  setQ,
  roleFilter,
  setRoleFilter,
  roleOptions,
  competitionFilter,
  setCompetitionFilter,
  sort,
  setSort,
  onResetFilters,
}) {
  return (
    <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <div className="mb-4 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-indigo-50 px-3 py-1 text-xs font-bold uppercase tracking-wide text-indigo-700 dark:bg-indigo-950/70 dark:text-indigo-300">
            <FaFilter />
            Filtres
          </div>

          <h2 className="mt-2 text-xl font-bold text-slate-900 dark:text-white">
            Rechercher un utilisateur
          </h2>
        </div>

        <button
          type="button"
          onClick={onResetFilters}
          className="inline-flex w-fit items-center justify-center gap-2 rounded-2xl bg-slate-100 px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700"
        >
          <FaTimes />
          Réinitialiser
        </button>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-12">
        <div className="relative lg:col-span-5">
          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            type="search"
            value={q}
            onChange={(event) => setQ(event.target.value)}
            placeholder="Nom, prénom, email, rôle, compétition..."
            className={`${INPUT} pl-11`}
          />
        </div>

        <select
          value={roleFilter}
          onChange={(event) => setRoleFilter(event.target.value)}
          className={`${INPUT} lg:col-span-2`}
        >
          <option value="all">Tous les rôles</option>
          {roleOptions.map((role) => (
            <option key={role.id} value={role.id}>
              {role.label}
            </option>
          ))}
        </select>

        <select
          value={competitionFilter}
          onChange={(event) => setCompetitionFilter(event.target.value)}
          className={`${INPUT} lg:col-span-2`}
        >
          <option value="all">Toutes compétitions</option>
          <option value="with">Avec compétition</option>
          <option value="without">Sans compétition</option>
        </select>

        <select
          value={sort}
          onChange={(event) => setSort(event.target.value)}
          className={`${INPUT} lg:col-span-3`}
        >
          <option value="name_az">Nom A → Z</option>
          <option value="name_za">Nom Z → A</option>
          <option value="email_az">Email A → Z</option>
          <option value="role_asc">Rôle</option>
          <option value="date_desc">Derniers inscrits</option>
        </select>
      </div>
    </section>
  );
}